<template>
    <div ref="nav" class="bg-dark d-flex flex-column flex-lg-row justify-content-center">
        <b-navbar type="dark" class="d-flex w-100 flex-row justify-content-between bg-nav">
            <div class="d-flex flex-row">
                <nav-brand/>
                <nav-desktop @logout="logout" v-if="$router.options.routes.filter(r => r.meta.nav).some(r => r.path ==  $route.path)"/>
            </div>
            <nav-mobile @logout="logout" v-if="$router.options.routes.filter(r => r.meta.nav).some(r => r.path ==  $route.path)"/>
        </b-navbar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { setAlert, setCookie } from '../tools'
import { routes } from '../config'
import { defaults } from "axios"
import { BNavbar } from "bootstrap-vue"
import NavDesktop from "./NavDesktop"
import NavMobile from "./NavMobile"
import NavBrand from "./NavBrand"
export default {
    name: "NavBar",
    components: {
        BNavbar,
        NavDesktop,
        NavMobile,
        NavBrand
    },
    computed: {
        ...mapGetters(['neueNachrichten']),
        routes: () => routes.filter(x => x.meta.nav)
    },
    watch: {
        neueNachrichten: function(curr, prev){
            if(curr > prev){
                navigator.vibrate([300, 200, 300])
                setAlert(this, 'Du hast eine neue Nachricht.', 'Neue Nachricht', 'info')
            }
        }
    },
    methods: {
        ...mapActions(['setNavHeight', 'startAnfragenInterval', 'clearUser', 'clearAnfragen']),
        logout() {
            defaults.headers.common['Authorization'] = undefined
            setCookie({ name: 'bszwmloginToken', value: "", exdays: -2 })
            this.clearUser()
            this.clearAnfragen()
            this.$router.push({ path: '/login', query: { redirect: true}})
            setAlert(this, 'Sie wurden erfolgreich abgemeldet.', 'Abmeldung', 'warning')
        }
    },
    mounted(){
        this.setNavHeight(this.$refs.nav.clientHeight)
        if (defaults.headers.common['Authorization'] != undefined) {
            this.startAnfragenInterval()
        }
    }

}
</script>
<style>
    .bg-nav{
        background-color:rgb(0, 57, 75)
    }
</style>